import styled from "styled-components";

export const SingleCollectionWrapper = styled.div`
  margin: 30px 0 50px;
`;

export const BannerHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 375px;
  & img {
    object-fit: cover;
    width: 100%;
    height: auto;
    max-height: 375px;
  }
`;

export const Shadow = styled.div`
  width: 100%;
  height: 375px;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(180deg, #000000 9.79%, rgba(0, 0, 0, 0) 80.35%);
`;

export const SingleCollectionMain = styled.div`
  display: flex;
  @media (max-width: 991.98px) {
    flex-direction: column;
  }
`;

export const SingleCollectionRight = styled.div`
  width: 70%;
  @media (max-width: 991.98px) {
    width: 100%;
  }
`;

export const BreadcrumpWrapper = styled.div`
  margin-bottom: 20px;
`;
